import { Box, Stack, Typography } from '@mui/material';
import { ChevronDownSmallIcon, TagSelect } from '@schooly/style';
import { forwardRef, ReactNode, useCallback, useImperativeHandle, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { CheckOverflow } from './CheckOverflow';

type FilterTagsProps = {
  label: string;
  selectLabel?: string;
  tags: () => ReactNode[];
  disabled?: boolean;
  width?: number;
  testId?: string;
  showLabel?: boolean;
  onClick?: () => void;
};

export type FilterTagsComponentRef = {
  hiddenTags: Set<number>;
};

export const FilterTags = forwardRef<FilterTagsComponentRef, FilterTagsProps>(
  ({ tags, label, selectLabel, disabled, width = 400, testId, showLabel = true, onClick }, ref) => {
    useImperativeHandle(ref, () => ({
      hiddenTags,
    }));

    const [hiddenTags, setHiddenTags] = useState<Set<number>>(new Set());

    const setTagHidden = useCallback((index: number, isHidden: boolean) => {
      setHiddenTags((tags) => {
        if (isHidden) {
          tags.add(index);
        } else {
          tags.delete(index);
        }
        return new Set(tags);
      });
    }, []);

    const tagNodes = tags().map((tagNode, i) =>
      i === 0 ? (
        tagNode
      ) : (
        <CheckOverflow index={i} onHideTag={setTagHidden} key={`_${i}`}>
          {tagNode}
        </CheckOverflow>
      ),
    );

    return (
      <Box
        flexDirection="row"
        sx={{
          cursor: disabled ? 'default' : 'pointer',
          position: 'relative',
        }}
        alignItems="center"
        onClick={() => !disabled && onClick?.()}
      >
        <Stack flexDirection="row" alignItems="center">
          {showLabel && (
            <Typography variant="h3" color="common.grey3" pr={1}>
              {label}
            </Typography>
          )}
          {tagNodes.length ? (
            tagNodes
          ) : (
            <Typography variant="h3">
              {label}: {selectLabel ?? <FormattedMessage id="filter-All" />}
            </Typography>
          )}{' '}
          {!!hiddenTags.size && (
            <TagSelect
              onClick={!disabled ? onClick : undefined}
              sx={(theme) => ({
                backgroundColor: 'white',
                ml: 0.5,
              })}
              label={`+${hiddenTags.size}`}
            />
          )}
          <Box ml={0.5}>
            <ChevronDownSmallIcon color="black" />
          </Box>
        </Stack>
      </Box>
    );
  },
);
